export default "__VITE_ASSET__TUX7b5h2__"